/* eslint-disable react/prop-types */
// Inspiration for this component from: https://react-router.now.sh/auth-workflow
// Routes user to the component if context shows them as being logged in
// Otherwise, routes them to the login page

import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function PrivateRoute({ component: Component, ...rest }) {
  const authed = useSelector((state) => state.auth.isAuthenticated)
  // const token = localStorage.getItem("token");
  return authed ? <Outlet /> : <Navigate to="/login" />
  // return (
  //   <Route
  //     {...rest}
  //     render={(props) =>
  //       authed === true ? (
  //         <Component {...props} />
  //       ) : (
  //         <Navigate to={{ pathname: '/', state: { from: props.location } }} />
  //       )
  //     }
  //   />
  // )
}

export default PrivateRoute
